import React, { Component } from "react";

import { getLanguageField } from "../../../../utils/language";
import TruncateText from "../../../../components/truncate";

import * as styles from "./policies.module.scss";


export default class Policies extends Component {
  render() {
    const { policies = [], language, title, buttonOpenText, buttonClosedText } = this.props;
    return (
      <div id={title} className="p-6 flex flex-col gap-4">
        <h3 className="text-lg font-bold">{title}</h3>
        <div className={styles.policies}>
          <TruncateText
            characters={300}
            buttonClassName={`inline-flex gap-1 items-center border-2 rounded-2xl py-1 px-4 w-fit mt-4 bg-white border-[color:var(--secondaryColor)] text-[color:var(--primaryColor)]`}
            buttonClosedText={buttonClosedText}
            buttonOpenText={buttonOpenText}
            text={policies.map(policy => {
              if (policy.policies_id.type === "post-booking") return undefined;
              return (
                <>
                  <h3 className="text-base font-bold">{getLanguageField(policy.policies_id.translations, language, 'name')}</h3>
                  <p className="text-sm">{getLanguageField(policy.policies_id.translations, language, 'description', true)}</p>
                </>
              )
            })}
          />
        </div>
      </div>
    )
  }
}